// Utilities to build and send WebSocket status messages for WeeklyReport
import { debugLog } from '../../utils/debug';

export type StatusEventData = {
  event: "sendmsg";
  data: {
    wr_id: number;
    status: number;
    user?: string;
    name?: string;
  };
};

export type JsonSender = (message: unknown) => void;

export enum WeeklyReportStatus {
  Using = 1,
  Release = 9,
}

export function buildStatusMessage(
  wrId: number,
  status: number,
  user?: string,
  name?: string
): StatusEventData {
  return {
    event: "sendmsg",
    data: { wr_id: wrId, status, user, name },
  };
}

export function sendStatus(
  sender: JsonSender,
  wrId: number,
  status: number,
  user?: string,
  name?: string
): void {
  sender(buildStatusMessage(wrId, status, user, name));
}

export function sendStatusUsing(
  sender: JsonSender,
  wrId: number,
  user?: string,
  name?: string
): void {
  const msg = buildStatusMessage(wrId, WeeklyReportStatus.Using, user, name);
  debugLog('WS', '送信 (Using):', msg);
  sender(msg);
}

export function sendStatusRelease(
  sender: JsonSender,
  wrId: number,
  user?: string,
  name?: string
): void {
  const msg = buildStatusMessage(wrId, WeeklyReportStatus.Release, user, name);
  debugLog('WS', '送信 (Release):', msg);
  sender(msg);
}